import styled from 'styled-components';
import NonFeasibleMessage from './NonFeasibleMessage';

export default styled(NonFeasibleMessage)`
  background-color: var(--primary50);
  border: 1px solid var(--primary200);
  padding: 1rem 2.6rem;
  border-radius: 4px;
  color: var(--grey800);
  font-size: 1.6rem;
  font-weight: 400;
  white-space: pre-line;
`;
